import angular from 'angular';
import { ReorderProductsListComponent } from './reorder-products-list.component';
// import CartService from '../../app/cart/cart.service';
// import SettingsService from '../../app/account/settings/settings.service';
// import CreditCardService from '../credit-card-list/credit-card.service';
// import AddressService from '../forms/account/address/address.service';
// import AddressListService from '../shipping-address-list/shipping-address-list.service';
import paging from '../../../../../components/paging';
export var ReorderProductsListModule = angular
    .module('directives.reorderProductsList', [
    paging
])
    // .service('CartService', CartService)
    // .service('SettingsService', SettingsService)
    // .service('CreditCardService', CreditCardService)
    // .service('AddressService', AddressService)
    // .service('AddressListService', AddressListService)
    .component('reorderProductsList', ReorderProductsListComponent)
    .name;
//# sourceMappingURL=reorder-products-list.module.js.map